import store from '@/store'
import { _isGreaterOrEqual } from '@/helpers/bigNumber'

let validateAmmount = (str) => {
  const inputAmmounts = store.getters['invoice/paymentIndications/expirationDates/totalAmount']
  const totalAmmount = store.getters['invoice/total']
  return _isGreaterOrEqual(totalAmmount, inputAmmounts)
}

export default validateAmmount
